document.addEventListener('DOMContentLoaded', function() {
    // すべてのチェックボックスを取得
    const checkboxes = document.querySelectorAll('.js-inspirationBlg__modal__sec__check__input');

    // 記事のリストを取得
    const articles = document.querySelectorAll('.js-inspirationBlg__list__blk');

    // ページロード時にチェックボックスの状態を復元
    restoreCheckboxState();

    // チェックボックスの変更イベントをリッスン
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            saveCheckboxState();
            filterArticles();
            updateSelectedTags();
        });
    });

    function filterArticles() {
        // チェックされたタグのリストを作成
        const selectedTypes = Array.from(document.querySelectorAll('.js-inspirationBlg__modal__sec__check__input--type:checked')).map(cb => cb.dataset.tagType);
        const selectedTastes = Array.from(document.querySelectorAll('.js-inspirationBlg__modal__sec__check__input--taste:checked')).map(cb => cb.dataset.tagTaste);

        // 記事をフィルタリング
        articles.forEach(article => {
            const articleTypes = article.dataset.tagType.trim().split(/\s+/);
            const articleTastes = article.dataset.tagTaste.trim().split(/\s+/);

            const matchesType = selectedTypes.length === 0 || selectedTypes.some(type => articleTypes.includes(type));
            const matchesTaste = selectedTastes.length === 0 || selectedTastes.some(taste => articleTastes.includes(taste));

            if (matchesType && matchesTaste) {
                article.style.display = 'block';
            } else {
                article.style.display = 'none';
            }
        });

        // モーダルを非表示にする
        let modalCnt = document.querySelector(".js-c-modalCnt");
        let modalCloseBack = document.getElementById("js-c-modalClose");

        setTimeout(function () {
            commonFadeOut(modalCnt, 400);
            commonFadeOut(modalCloseBack, 400);
            modalCnt.classList.remove("js-c-modalCnt--open");

            if (typeof window.unlockScroll === 'function') {
                window.unlockScroll();  // 安全呼び
            }
        }, 800);
    }

    function updateSelectedTags() {
        // 選択中のタグを表示する要素を取得
        const selectedTagsContainer = document.getElementById('js-inspirationBlg__search__selected');
        // リセットしてから再描画
        selectedTagsContainer.innerHTML = '';

        // 選択中のタグをリストアップ
        const selectedTypes = Array.from(document.querySelectorAll('.js-inspirationBlg__modal__sec__check__input--type:checked')).map(cb => cb.dataset.tagType);
        const selectedTastes = Array.from(document.querySelectorAll('.js-inspirationBlg__modal__sec__check__input--taste:checked')).map(cb => cb.dataset.tagTaste);

        // タグに応じてテキストを設定して表示
        selectedTypes.forEach(tag => {
            const tagElement = document.createElement('li');
            tagElement.textContent = convertTagToText(tag);
            tagElement.setAttribute('data-checked', tag); // data-checked属性を追加
            tagElement.classList.add('js-inspirationBlg__search__selected__child'); // クラスを追加
            selectedTagsContainer.appendChild(tagElement);
        });

        selectedTastes.forEach(tag => {
            const tagElement = document.createElement('li');
            tagElement.textContent = convertTagToText(tag);
            tagElement.setAttribute('data-checked', tag); // data-checked属性を追加
            tagElement.classList.add('js-inspirationBlg__search__selected__child'); // クラスを追加
            selectedTagsContainer.appendChild(tagElement);
        });
    }

    // クリックされたタグをチェックボックスと連動してフィルタリングする
    document.getElementById('js-inspirationBlg__search__selected').addEventListener('click', function(event) {
        if (event.target.tagName === 'LI') {
            const tag = event.target.getAttribute('data-checked');
            const correspondingCheckbox = document.querySelector(`.js-inspirationBlg__modal__sec__check__input[data-tag-type="${tag}"], .js-inspirationBlg__modal__sec__check__input[data-tag-taste="${tag}"]`);
            if (correspondingCheckbox) {
                correspondingCheckbox.checked = !correspondingCheckbox.checked; // チェックボックスのチェック状態を反転させる
                filterArticles(); // チェックボックスの変更イベントをトリガーしてフィルタリングを実行する
                event.target.remove(); // クリックされた<li>要素を削除する
                saveCheckboxState(); // チェックボックスの状態を保存
                updateSelectedTags(); // 選択されたタグを更新
            }
        }
    });

    // タグをテキストに変換する関数
    function convertTagToText(tag) {
        switch (tag) {
            // styling type
            case 'rsTypeLiving':
                return 'リビング';
            case 'rsTypeDining':
                return 'ダイニング';
            case 'rsTypeWork':
                return 'ワークスペース';
            case 'rsType1R1LDK':
                return '1R / 1LDK';
            case 'rsTypeBed':
                return 'ベッドルーム';
            case 'rsTypeKids':
                return 'キッズルーム';
            case 'rsTypeSmall':
                return '小スペース';
            case 'rsTypeOutdoor':
                return '屋外';
            // styling taste
            case 'rsTasteModern':
                return 'モダン';
            case 'rsTasteMidCentury':
                return 'ミッドセンチュリー';
            case 'rsTasteNatural':
                return 'ナチュラル';
            case 'rsTasteNordic':
                return '北欧';
            case 'rsTasteClassic':
                return 'クラシック';
            case 'rsTasteVintage':
                return 'ヴィンテージ/インダストリアル';
            case 'rsTasteOther':
                return 'その他';
            // works type
            case 'wsTypeHouse':
                return 'ハウス';
            case 'wsTypeHotel':
                return 'ホテル';
            case 'wsTypeOffice':
                return 'オフィス';
            case 'wsTypeShop':
                return 'ショップ';
            case 'wsTypeOther':
                return 'その他';
            // works taste
            case 'wsTasteModern':
                return 'モダン';
            case 'wsTasteMidCentury':
                return 'ミッドセンチュリー';
            case 'wsTasteNatural':
                return 'ナチュラル';
            case 'wsTasteNordic':
                return '北欧';
            case 'wsTasteClassic':
                return 'クラシック';
            case 'wsTasteVintage':
                return 'ヴィンテージ';
            case 'wsTasteOther':
                return 'その他';
            default:
                return tag; // デフォルトはタグそのものを表示
        }
    }

    function saveCheckboxState() {
        const checkedState = {};
        checkboxes.forEach(checkbox => {
            checkedState[checkbox.dataset.tagType || checkbox.dataset.tagTaste] = checkbox.checked;
        });
        sessionStorage.setItem('checkboxState', JSON.stringify(checkedState));
    }

    function restoreCheckboxState() {
        const checkedState = JSON.parse(sessionStorage.getItem('checkboxState') || '{}');
        checkboxes.forEach(checkbox => {
            const tag = checkbox.dataset.tagType || checkbox.dataset.tagTaste;
            if (checkedState[tag]) {
                checkbox.checked = true;
            }
        });
        filterArticles();
        updateSelectedTags();
    }

    // 初期フィルタリングと選択中のタグ表示を実行
    filterArticles();
    updateSelectedTags();
});
